<template>
  <b-overlay :show="loading">
    <add-or-update-sample-csv-form ref="sampleCSVFileForm" @create="onCreateNewSampleCSVFile" />
  </b-overlay>
</template>

<script>
import { get } from "lodash"
import { BOverlay } from "bootstrap-vue"

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddOrUpdateSampleCsvForm from "@/@core/components/shared/sample-csv-files/AddOrUpdateSampleCSVForm.vue"

export default {
  name: 'CreateNewSampleCSVFile',
  components: {
    BOverlay,
    AddOrUpdateSampleCsvForm
  },
  directives: {},
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async onCreateNewSampleCSVFile(sample_csv_file){
      try {
        this.loading = true;

        await this.useJwt().mainService.sampleCSVFiles.create(sample_csv_file);
        this.$refs.sampleCSVFileForm.resetForm();

        await this.$router.push({
          name: "admin-sample-csv-files"
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Succcess',
            icon: 'EditIcon',
            variant: 'success',
            text: `Sample file created successfully`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
